/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import moment from 'moment';
import { Form, Input, Select, Button, message, Row, Col, DatePicker } from 'antd';
import { DmsTab } from 'Components';
import { saveOrUpdateSeller, sellerDetail } from '../../service/store/staff';
import { sKeylist } from '../../service/dictionary/dataitem';
import {nameValidator,checkQQ,checkWeiXin,checkTel,checkPhone} from '../../utils/regexp.js';
import {showSpin,hideSpin} from 'Utils';
const FormItem = Form.Item;

class StaffAdd extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      shopId: parseInt(this.props.params.storeId, 10),
      staffId: parseInt(this.props.params.staffId, 10),
      detail: {},
      sex: [],
      post_type: []
    }
  }

  componentWillMount () {
    const self = this;
    sKeylist({ sKey: 'sex' }).then(res => { //性别
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ sex: res.data })
        }
      }, 200);
    })
    sKeylist({ sKey: 'store_post_type' }).then(res => { //岗位
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          if(self.state.staffId > 0){
            self.setState({ post_type: res.data })
          }else{
            self.setState({ post_type: res.data.filter(x => x.sKey == 0) })
          }
        }
      }, 200);
    })
  }

  componentDidMount () {
    const self = this;
    this.mounted = true;
    if (this.state.staffId > 0) {
      sellerDetail(this.state.staffId).then(res => {
        if (res.status) {
          let data = res.data.dmsSellerVo
          //ContactInfo, dmsContactInfoMapList
          if(data.dmsContactInfoMapList){
            data.dmsContactInfoMapList.forEach(x => {
              data[`ContactInfo_${x.type}`] = x.content
            });
          }
          self.setState({
            detail: data
          })
        }
      });
    }
  }

  cancelHandle () {
    hashHistory.goBack()
  }

  submitHandle () {
    const { staffId, shopId } = this.state;
    const { validateFields, getFieldsValue } = this.props.form;

    validateFields((errors) => {//表单校验
      if (errors) {
        return
      }//表单校验有误，则不执行下面的代码
      const data = {
        ...getFieldsValue() //获取用户输入
      };
      let dmsContactInfoList = [];
      Object.keys(data).forEach((key) => {
        if (key.match('ContactInfo')) {
          dmsContactInfoList.push({
            content: data[key], //联系方式内容 ,
            type: parseInt(key.split('_')[1], 10), // (integer, optional): 联系方式类型：1-手机；2-座机；3-Email；4-QQ；5-微信；6-钉钉
          });
          delete data[key]; //删除冗余数据
        }
      });
      // console.log(`你正在提交数据：${JSON.stringify({ ...data, dmsContactInfoList })}`);

      showSpin();
      if (staffId > 0) {
        saveOrUpdateSeller({ ...data, shopId, dmsContactInfoList, id: staffId }).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && hashHistory.goBack();
        });
      } else {
        saveOrUpdateSeller({ ...data, shopId, dmsContactInfoList }).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && hashHistory.goBack();
        });
      }
    })
  }

  render () {
    const { detail, sex, post_type, staffId } = this.state;
    const { getFieldDecorator } = this.props.form;
    return <div className="dms-body">
      <DmsTab options={['新增员工']} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="姓名：" hasFeedback>
                {getFieldDecorator('name', {
                  initialValue: detail.name || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入姓名'
                    },
					  {
						  validator: nameValidator
					  }
                  ],
                })(<Input placeholder="请输入姓名"/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <div id="activeBox">
                <FormItem label="状态：" hasFeedback>
                  {getFieldDecorator('active', {
                    initialValue: detail.active ? detail.active.toString() : '1',
                    rules: [
                      {
                        required: true,
                        message: '请选择状态'
                      },
                    ]
                  })(
                    <Select style={{ width: '100%' }}
                            getPopupContainer={() => document.getElementById('activeBox')}>
                      <Select.Option key="0" value="0">离职</Select.Option>
                      <Select.Option key="1" value="1">在职</Select.Option>
                    </Select>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="sexBox">
                <FormItem label="性别：" hasFeedback>
                  {getFieldDecorator('sex', {
                    initialValue: detail.sex ? detail.sex.toString() : '',
                    rules: [
                      {
                        required: false,
                        message: '请选择性别'
                      },
                    ]
                  })(
                    <Select style={{ width: '100%' }}
                            getPopupContainer={() => document.getElementById('sexBox')}>
                      {
                        sex.map((item, index) => {
                          return <Select.Option key={index + ''} value={item.sKey}>{item.name}</Select.Option>
                        })
                      }
                    </Select>)}
                </FormItem>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div id="postBox">
                <FormItem label="岗位：" hasFeedback>
                  {getFieldDecorator('post', {
                    initialValue: staffId > 0 ? (detail.post ? detail.post.toString() : '') : '0',
                    rules: [
                      {
                        required: true,
                        message: '请选择岗位'
                      },
                    ]
                  })(
                    <Select style={{ width: '100%' }}
                            getPopupContainer={() => document.getElementById('postBox')}>
                      {
                        post_type.map((item, index) => {
                          return <Select.Option key={index + ''} value={item.sKey}>{item.name}</Select.Option>
                        })
                      }
                    </Select>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="手机：" hasFeedback>
                {getFieldDecorator('ContactInfo_1', {
                  initialValue: detail.ContactInfo_1 || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入手机'
                    },
					  {
						  validator: checkPhone
					  }
                  ]
                })(<Input/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="座机：" hasFeedback>
                {getFieldDecorator('ContactInfo_2', {
                  initialValue: detail.ContactInfo_2 || '',
                  rules: [
                    {
                      required: false,
                      message: '请输入座机'
                    },
					  {
						  validator: checkTel
					  }
                  ]
                })(<Input/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="birthdayBox">
                <FormItem label="生日：" hasFeedback>
                  {getFieldDecorator('birthday', {
                    initialValue: detail.birthday ? moment((new Date(detail.birthday)), 'YYYY-MM-DD') : null,
                    rules: [
                      {
                        required: false,
                        message: '请输入选择生日'
                      },
                    ]
                  })(<DatePicker style={{ width: '100%' }}
                                 getCalendarContainer={() => document.getElementById('birthdayBox')}/>)}
                </FormItem>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="QQ：" hasFeedback>
                {getFieldDecorator('ContactInfo_4', {
                  initialValue: detail.ContactInfo_4 || '',
                  rules: [
                    {
                      required: false,
                      message: '请输入QQ'
                    },
					  {
						  validator:checkQQ
					  }
                  ]
                })(<Input/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="Email：" hasFeedback>
                {getFieldDecorator('ContactInfo_3', {
                  initialValue: detail.ContactInfo_3 || '',
                  rules: [
                    {
                      type: 'email',
                      message: '请输入正确的邮箱号码'
                    }
                  ]
                })(<Input/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="微信：" hasFeedback>
                {getFieldDecorator('ContactInfo_5', {
                  initialValue: detail.ContactInfo_5 || '',
                  rules: [
                    {
                      required: false,
                      message: '请输入微信'
                    },
					  {
						  validator: checkWeiXin
					  }
                  ]
                })(<Input/>)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  }
}
export default Form.create()(StaffAdd)


// WEBPACK FOOTER //
// ./src/routes/staff/add.js